export const ReportIcon = ({ ...rest }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="#7C3AED"
        fillOpacity="0.1"
      />
      <path
        d="M23.3333 15.8333H28.3333V20.8333"
        stroke="#7C3AED"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3333 15.8333L21.25 22.9167L17.0833 18.75L11.6667 24.1667"
        stroke="#7C3AED"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
